<template>
  <div>
    <va-inner-loading :loading="loading">
      <reviews-table
        class="mb-4"
        :reviews="reviews"
        :loading="loading"
        @refresh="fetchReviews"
      />
    </va-inner-loading>
  </div>
</template>

<script>
import api from "@/api/axios";
import ReviewsTable from "../../components/reviews/reviews-table.vue";

export default {
  name: "Reviews",
  components: {
    ReviewsTable,
  },
  data() {
    return {
      reviews: [],
      loading: false,
    };
  },
  created() {
    this.fetchReviews();
  },
  methods: {
    async fetchReviews() {
      this.loading = true;
      try {
        const response = await api.get("/admin/feedback", {
          params: {
            all: 1,
          },
        });
        this.reviews = response.data.data || [];
      } catch (error) {
        console.error("Ошибка загрузки отзывов:", error);
        this.reviews = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
